var map = {
	"./edm-1.png": "./src/img/works/edm/edm-1.png",
	"./edm-2.png": "./src/img/works/edm/edm-2.png",
	"./edm-3.png": "./src/img/works/edm/edm-3.png",
	"./edm-4.png": "./src/img/works/edm/edm-4.png",
	"./edm-5.png": "./src/img/works/edm/edm-5.png",
	"./edm-6.png": "./src/img/works/edm/edm-6.png",
	"./edm-pop-1.png": "./src/img/works/edm/edm-pop-1.png",
	"./edm-pop-2.png": "./src/img/works/edm/edm-pop-2.png",
	"./edm-pop-3.png": "./src/img/works/edm/edm-pop-3.png",
	"./edm-pop-4.png": "./src/img/works/edm/edm-pop-4.png",
	"./edm-pop-5.png": "./src/img/works/edm/edm-pop-5.png",
	"./edm-pop-6.png": "./src/img/works/edm/edm-pop-6.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/works/edm sync \\.(png%7Cjpe?g%7Csvg)$";